import styled from "styled-components";

export const Wrapper = styled.div`
  .billing-coupons-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }

  .billing-coupons-title {
    font-size: 18px;
    font-weight: 800;
    color: var(--app-text);
    letter-spacing: -0.02em;
  }

  .billing-coupons-subtitle {
    margin-top: 4px;
    font-size: 13px;
    color: var(--app-text-muted);
  }

  .billing-coupons-toolbar {
    background: var(--app-surface);
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
  }

  .billing-coupons-table-header-row {
    color: var(--app-text) !important;
  }

  .billing-coupons-code {
    font-weight: 800;
    letter-spacing: 0.05em;
    color: var(--app-text);
  }

  .billing-coupons-plan-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .billing-coupons-plan-tag {
    margin: 0;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
  }

  /* ── Create coupon modal ─────────────────────────────────────────── */
  .billing-coupons-modal {
    .ant-modal-content {
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 24px 48px rgba(17, 24, 39, 0.12);
    }

    .ant-modal-header {
      padding: 22px 24px 18px;
      border-bottom: 1px solid var(--app-border);
      margin-bottom: 0;
      background: var(--app-surface);
    }

    .ant-modal-body {
      padding: 0;
      background: var(--app-surface);
    }

    .ant-modal-footer {
      padding: 16px 24px 20px;
      border-top: 1px solid var(--app-border);
      margin-top: 0;
      background: var(--app-surface);
    }
  }

  .billing-coupons-modal-title {
    font-size: 17px;
    font-weight: 800;
    color: var(--app-text);
    letter-spacing: -0.02em;
    line-height: 1.3;
  }

  .billing-coupons-form {
    padding: 20px 24px 8px;
  }

  .billing-coupons-form .ant-form-item {
    margin-bottom: 16px;
  }

  .billing-coupons-form .ant-form-item:last-child {
    margin-bottom: 0;
  }

  .billing-coupons-form .ant-form-item-label > label {
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    height: auto;
  }

  .billing-coupons-form .ant-form-item-explain-error {
    font-size: 12px;
    margin-top: 4px;
  }

  .billing-coupons-form .ant-row {
    row-gap: 0;
  }

  .billing-coupons-input-icon {
    color: #f45b68;
    font-size: 14px;
  }

  .billing-coupons-form-input.ant-input,
  .billing-coupons-form-input.ant-input-affix-wrapper,
  .billing-coupons-form-input.ant-input-number,
  .billing-coupons-form-input.ant-input-number .ant-input-number-input {
    height: 42px !important;
    border-radius: 10px !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .billing-coupons-form-input.ant-input-affix-wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }

  .billing-coupons-form-input.ant-input:hover,
  .billing-coupons-form-input.ant-input-affix-wrapper:hover,
  .billing-coupons-form-input.ant-input-number:hover {
    border-color: rgba(244, 91, 104, 0.35) !important;
  }

  .billing-coupons-form-input.ant-input:focus,
  .billing-coupons-form-input.ant-input-affix-wrapper-focused,
  .billing-coupons-form-input.ant-input-number-focused {
    border-color: rgba(244, 91, 104, 0.55) !important;
    box-shadow: 0 0 0 3px rgba(244, 91, 104, 0.1) !important;
  }

  .billing-coupons-form-input.ant-input-number {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .billing-coupons-form-input .ant-input-number-group-addon,
  .billing-coupons-form-input .ant-input-suffix {
    color: var(--app-text-muted);
    font-size: 12px;
    font-weight: 600;
    background: transparent;
    border-color: var(--app-border);
  }

  .billing-coupons-form-input.ant-input::placeholder,
  .billing-coupons-form-input.ant-input-number-input::placeholder {
    color: var(--app-text-muted) !important;
    font-weight: 400 !important;
    opacity: 0.85;
  }

  .billing-coupons-plans-select.ant-select {
    width: 100%;
  }

  .billing-coupons-plans-select .ant-select-selector {
    min-height: 42px !important;
    border-radius: 10px !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .billing-coupons-plans-select.ant-select:hover .ant-select-selector {
    border-color: rgba(244, 91, 104, 0.35) !important;
  }

  .billing-coupons-plans-select.ant-select-focused .ant-select-selector {
    border-color: rgba(244, 91, 104, 0.55) !important;
    box-shadow: 0 0 0 3px rgba(244, 91, 104, 0.1) !important;
  }

  .billing-coupons-plans-select .ant-select-selection-item,
  .billing-coupons-plans-select .ant-select-selection-placeholder,
  .billing-coupons-plans-select .ant-select-selection-search-input {
    color: var(--app-text) !important;
    font-size: 13px !important;
    font-weight: 500 !important;
  }

  .billing-coupons-plans-select .ant-select-selection-placeholder {
    color: var(--app-text-muted) !important;
    font-weight: 400 !important;
  }

  .billing-coupons-plans-select .ant-select-selection-item {
    border-radius: 999px !important;
    background: rgba(244, 91, 104, 0.1) !important;
    border: 1px solid rgba(244, 91, 104, 0.22) !important;
    color: #f45b68 !important;
    font-weight: 700 !important;
  }

  @media (max-width: 768px) {
    .billing-coupons-toolbar {
      justify-content: stretch;
    }

    .billing-coupons-toolbar .ant-btn {
      flex: 1;
    }
  }
`;
